module.exports = __webpack_public_path__ + "img/ic_reload.9b6b6818.svg";